import React from "react";
import { Analytics, Pipeline } from "./components";
import { useSelector } from "react-redux";
import FirstTimeModal from "../dashboard/components/modal";
import "./styles.scss";
import { ENTERPRISE_ROLE } from "../../../../constant";

function CompaniesOverview() {
  const user = useSelector((state) => state.UserReducer.profile);
  // TODO: uncomment this when we restrict professional users from accessing enterprise features
  // const analyticsPreview = user?.organization && user?.role === ENTERPRISE_ROLE;
  const analyticsPreview = user?.organization;

  return (
    <div className="companies-overview-wrapper">
      <h2 className="page-title">Firm Overview</h2>
      {analyticsPreview && <Analytics />}
      <Pipeline />
      <FirstTimeModal previewToggle />
    </div>
  );
}

export default CompaniesOverview;
